export const RECAPTCHA_SITE_KEY = '6LcE1WoUAAAAAFWk8ilHYO9jA-h9LLRMDxBEHwmb'
